// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {
    buildCurrency,
    buildNumber
} from '../../../shared/services/build-number';
import ActionsPopover from '../../../shared/components/actions-popover';
import AuditRecordingClaim from '@deere/cps-it.warranty-model-factory/lib/audit-recording-claim';
import {FormattedMessage} from 'react-intl';
import LabeledLink from '../../../product/shared/components/labeled-link';
import LabeledSmartFormLink from '../../../shared/components/labeled-smart-form-link/labeled-smart-form-link';
import LabeledString from '../../../shared/components/labeled-string';
import {Link} from 'react-router';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';
import {getRecordAuditActions} from '../services/record-audit-helper';

const ClaimAuditItem = (props, context) => {

    const claimRoute = buildClaimRoutes(props.claim.claimType.key, props.claim.subClaimType.key, props.claim.claimNumber);

    const userLanguage = context.user.getLocale();

    const data = {
        auditNumber: props.auditNumber,
        claim: props.claim,
        language: userLanguage,
        route: claimRoute
    };

    const actionList = getRecordAuditActions(data, props.onFullDebitModalOpen.bind(null, props.claim.claimNumber), context.security);

    return (
        <section className='claim-audit-item'>
            <header className='claim-audit-item-title'>
                <Link
                    rel='noopener noreferrer'
                    target='_blank'
                    to={claimRoute}
                >
                    <FormattedMessage
                        id='CLAIM_WITH_NUMBER'
                        values={{
                            claimNumber: formatClaimNumber(props.claim.claimNumber)
                        }}
                    />
                </Link>
                <div className='recovery-percentage'>
                    <FormattedMessage
                        id='CLAIM_RECOVER_PERCENTAGE'
                        values={{
                            percentage: buildNumber(props.claim.reimbursementDetails.reimbursementPercentage)
                        }}
                    />
                </div>
            </header>
            <div className='row'>
                <LabeledString
                    data={props.claim.workOrder}
                    label='WORK_ORDER_ONE'
                />
                <LabeledString
                    className='labeled-currency'
                    data={`${buildCurrency(props.claim.reimbursementDetails.requestedAmount)}(${props.claim.reimbursementDetails.currency.value})`}
                    label='REQUESTED'
                />
                <LabeledString
                    data={`${buildCurrency(props.claim.reimbursementDetails.withAdditives)}(${props.claim.reimbursementDetails.currency.value})`}
                    label='WITH_ADDITIVES'
                />
            </div>
            <div className='row'>
                {props.claim.claimType.key === 'ZZMK' ?
                    <LabeledString
                        className='claim-type'
                        data={props.claim.subClaimType.value}
                        label='CLAIM_TYPE'
                    /> :
                        <LabeledString
                            className='claim-type'
                            data={props.claim.claimType.value}
                            label='CLAIM_TYPE'
                        />
                }
                <LabeledString
                    className='labeled-currency'
                    data={`${buildCurrency(props.claim.reimbursementDetails.approvedAmount)}(${props.claim.reimbursementDetails.currency.value})`}
                    label='APPROVED'
                />
                <LabeledSmartFormLink
                    displayText={props.claim.creditMemoNumber}
                    formName='CREDITMEMO'
                    label='CREDIT_MEMO'
                    objectId={props.claim.creditMemoNumber}
                />
            </div>
            <div className='row'>
                <LabeledLink
                    data={props.claim.pin}
                    href={`#/products/${props.claim.pin}`}
                    label='PIN'
                />
                <LabeledString
                    data={props.claim.debitType.value}
                    label='DEBIT_TYPE'
                />
                <LabeledString
                    className='labeled-currency'
                    data={`${buildCurrency(props.claim.debitAmount)}(${props.claim.reimbursementDetails.currency.value})`}
                    label='DEBIT_AMOUNT'
                />
            </div>
            <LabeledString
                data={props.claim.comments}
                label='COMMENTS'
            />
            {actionList.length > 0 &&
                <footer>
                    <ActionsPopover options={actionList}/>
                </footer>
            }
        </section>
    );

};

ClaimAuditItem.displayName = 'ClaimAuditItem';
ClaimAuditItem.propTypes = {
    auditNumber: PropTypes.string.isRequired,
    claim: PropTypes.instanceOf(AuditRecordingClaim).isRequired,
    onFullDebitModalOpen: PropTypes.func.isRequired,
    onPartialDebitModalOpen: PropTypes.func.isRequired
};
ClaimAuditItem.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimAuditItem;



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/claim-audit-item.js